import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "absolute top-0 right-0 p-8 flex space-x-8"
};
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
}, null, -1);
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
}, null, -1);
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "m-auto w-full max-w-md p-8"
};
const _hoisted_9 = {
  class: "p-8 text-center"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  class: "uppercase text-xs tracking-widest text-gray-400 font-semibold"
}, "Counter", -1);
const _hoisted_11 = ["textContent"];
const _hoisted_12 = {
  class: "flex"
};
const _hoisted_13 = {
  class: "text-sm mt-8"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-xs font-semibold text-gray-400"
}, "Wallet address:", -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-xs font-semibold text-gray-400 mt-4"
}, "Counter address:", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_wallet_multi_button = _resolveComponent("wallet-multi-button");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-screen w-screen flex", $setup.dark ? 'bg-gray-900 text-gray-100' : 'bg-gray-100 text-gray-700'])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = $event => $setup.dark = !$setup.dark),
    class: _normalizeClass(["rounded-full p-3", $setup.dark ? 'bg-white/10 hover:bg-white/20 text-gray-200' : 'bg-black/10 hover:bg-black/20 text-gray-600'])
  }, [$setup.dark ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4)) : (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))], 2), _createVNode(_component_wallet_multi_button, {
    dark: $setup.dark
  }, null, 8, ["dark"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: _normalizeClass(["shadow-xl rounded-xl", $setup.dark ? 'bg-gray-700' : 'bg-white'])
  }, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("p", {
    class: _normalizeClass(["font-bold text-5xl mt-2", $setup.dark ? 'text-white' : 'text-gray-900']),
    textContent: _toDisplayString($setup.counterPublicKey ? $setup.counter : 'Not Set')
  }, null, 10, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
    class: _normalizeClass(["flex-1 py-4 px-2 rounded-bl-xl", $setup.dark ? 'hover:bg-gray-800' : 'hover:bg-gray-100']),
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.createCounter && $setup.createCounter(...args))
  }, " New Counter ", 2), _createElementVNode("button", {
    class: _normalizeClass(["flex-1 py-4 px-2 rounded-br-xl", $setup.dark ? 'hover:bg-gray-800' : 'hover:bg-gray-100']),
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.incrementCounter && $setup.incrementCounter(...args))
  }, " Increment Counter ", 2)])], 2), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("p", null, _toDisplayString(_ctx.$wallet.publicKey.value?.toBase58() ?? "Not connected"), 1), _hoisted_15, _createElementVNode("p", null, _toDisplayString($setup.counterPublicKey ?? "Not created"), 1)])])], 2);
}